import styles from './CustomNumber.module.css'
import { useState, useRef } from 'react'

function CustomNumber({ name, value, onChange, min, step }) {
  const [intervalId, setIntervalId] = useState(null)
  const valueRef = useRef(value)
  const parsedValue = parseFloat(value)
  valueRef.current = parseFloat(value)

  const startIncrease = () => {
    clearInterval(intervalId)
    increase()
    const id = setInterval(increase, 100)
    setIntervalId(id)
  }

  const startDecrease = () => {
    clearInterval(intervalId)
    decrease()
    const id = setInterval(decrease, 100)
    setIntervalId(id)
  }

  const stopChange = () => {
    clearInterval(intervalId)
    setIntervalId(null)
  }

  const increase = () => {
    onChange({ target: { value: valueRef.current + step, name } })
  }

  const decrease = () => {
    if (valueRef.current - step >= min) {
      onChange({ target: { value: valueRef.current - step, name } })
    }
  }

  const handleInputChange = (event) => {
    let inputValue = parseFloat(event.target.value)

    if (isNaN(inputValue)) {
      inputValue = min
    }

    if (inputValue >= min) {
      onChange({ target: { value: inputValue, name } })
    }
  }

  return (
    <div className={styles.container}>
      <button
        className={styles.decrease}
        onMouseDown={startDecrease}
        onMouseUp={stopChange}
        onMouseLeave={stopChange}
      >
        <svg
          width="12"
          height="12"
          viewBox="0 0 12 12"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M2 6a.75.75 0 0 1 .75-.75h6.5a.75.75 0 0 1 0 1.5h-6.5A.75.75 0 0 1 2 6Z"
            fill="currentColor"
          />
        </svg>
      </button>
      <input
        type="number"
        name={name}
        value={parsedValue}
        onChange={handleInputChange}
        min={min}
        step={step}
        className={styles.input__size}
      />
      <button
        className={styles.increase}
        onMouseDown={startIncrease}
        onMouseUp={stopChange}
        onMouseLeave={stopChange}
      >
        <svg
          width="12"
          height="12"
          viewBox="0 0 12 12"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M5.25 9.25a.75.75 0 0 0 1.5 0v-2.5h2.5a.75.75 0 0 0 0-1.5h-2.5v-2.5a.75.75 0 0 0-1.5 0v2.5h-2.5a.75.75 0 0 0 0 1.5h2.5v2.5Z"
            fill="currentColor"
          />
        </svg>
      </button>
    </div>
  )
}

export default CustomNumber
